<div fxFlexFill class="presentation">
  <div fxFlex>
    <router-outlet (activate)="setScrollUp()"></router-outlet>
  </div>
</div>
